/**
 * @fileoverview Composant racine de la console backoffice GNPC.
 *
 * Enveloppe le routeur et les providers globaux (Toaster pour les toasts
 * Sonner, TooltipProvider pour l'ensemble de l'app). Aucune logique métier
 * ici — la navigation et les guards de route vivent dans `router.tsx`.
 */

import { RouterProvider } from 'react-router-dom';
import { Toaster, TooltipProvider } from '@gnpc/ui';
import { router } from './router.tsx';
import { CapabilityProvider } from './features/auth/CapabilityProvider.tsx';

/**
 * Racine de l'application.
 *
 * - `TooltipProvider` : parent unique pour tous les tooltips ; évite qu'un
 *   provider local rate le portail Radix.
 * - `Toaster` : monté une seule fois, à la racine. Rendu dans un portail,
 *   position par défaut en bas à droite (config Sonner interne).
 * - `richColors` : force les couleurs sémantiques par variante (success,
 *   error, warning, info) au lieu du fond neutre par défaut.
 */
export function App(): JSX.Element {
  return (
    <TooltipProvider>
      <CapabilityProvider>
        <RouterProvider router={router} />
        <Toaster richColors closeButton position="bottom-right" />
      </CapabilityProvider>
    </TooltipProvider>
  );
}
